'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_layouts_MainLayout$$anon$2() {
}
export { $c_Lapp_layouts_MainLayout$$anon$2 as $c_Lapp_layouts_MainLayout$$anon$2 };
$c_Lapp_layouts_MainLayout$$anon$2.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_s_Conversion();
$c_Lapp_layouts_MainLayout$$anon$2.prototype.constructor = $c_Lapp_layouts_MainLayout$$anon$2;
/** @constructor */
function $h_Lapp_layouts_MainLayout$$anon$2() {
}
export { $h_Lapp_layouts_MainLayout$$anon$2 as $h_Lapp_layouts_MainLayout$$anon$2 };
$h_Lapp_layouts_MainLayout$$anon$2.prototype = $c_Lapp_layouts_MainLayout$$anon$2.prototype;
$c_Lapp_layouts_MainLayout$$anon$2.prototype.apply__O__O = (function(x) {
  var this$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_laminar_api_package$().Lcom_raquo_laminar_api_package$__f_L;
  var modifiers = x.forAnchor__sci_Seq();
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_$less$colon$less$();
  var asModifier = this$2.s_$less$colon$less$__f_singleton;
  var renderableSeq = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$();
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__seqToModifier__O__F1__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier(this$3, modifiers, asModifier, renderableSeq);
});
var $d_Lapp_layouts_MainLayout$$anon$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_layouts_MainLayout$$anon$2, "app.layouts.MainLayout$$anon$2", ({
  Lapp_layouts_MainLayout$$anon$2: 1,
  s_Conversion: 1,
  F1: 1
}));
export { $d_Lapp_layouts_MainLayout$$anon$2 as $d_Lapp_layouts_MainLayout$$anon$2 };
//# sourceMappingURL=app.layouts.-Main-Layout$$anon$2.js.map
